import { Tag } from "lucide-react";
import { toast } from "sonner";
import { downloadFile } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const printEtiquettes = (demande, format = "rouleau", ids = []) => {
  localStorage.setItem("etiquettes_format", format);
  return downloadFile(`/demandes/${demande.id}/etiquettes/pdf?format=${format}${ids.length ? `&ids=${ids.join(",")}` : ""}`, `etiquettes_${demande.numero}.pdf`)
    .catch(() => toast.error("Impression des étiquettes impossible"));
};

export const EtiquettesButtons = ({ demande }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="etiquettes-buttons">
    <Tag className="h-4 w-4 text-slate-500" />
    <span className="text-sm text-slate-600">Étiquettes à code-barres :</span>
    <Button size="sm" variant="outline" onClick={() => printEtiquettes(demande, "rouleau")} data-testid="etiquettes-rouleau-button">Imprimante d'étiquettes (57×32 mm)</Button>
    <Button size="sm" variant="outline" onClick={() => printEtiquettes(demande, "planche")} data-testid="etiquettes-planche-button">Planche Letter (30 par page)</Button>
  </div>
);
